import { apiWithkey } from "../axios";
import { baseApiURL, forbiddenWords, validateCouponApi } from "../endpoints";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import useInsuranceStore from "../../storeModules/useInsuranceStore";
import findStep from "../../screens/bot/stepModules/findStep";
import { couponCategories } from "../../utils/constants";
import removeSpecialCharacters from "../../utils/removeSpecialCharacters";
import usePaymentStore from "../../storeModules/usePaymentStore";

const validateForbiddenWords = async (word, message, nextStep, inputType) => {
  const url = `${baseApiURL}${forbiddenWords}`;
  const data = JSON.stringify(word);

  const config = {
    method: "post",
    url,
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    data,
  };

  return apiWithkey
    .request(config)
    .then(async (response) => {
      const { data } = response;

      if (!data.success) {
        data.errorMessage = message;
      }

      data.inputType = inputType;
      data.nextStep = nextStep;
      return data;
    })
    .catch(() => {
      useBotControlStore.setState({
        currentStep: findStep("erro_geral").index,
      });
    });
};

const validateCoupon = async () => {
  const url = new URL(`${baseApiURL}${validateCouponApi}`);

  const { bemCredito, tipoPlanoID } =
    useConsorcioStore.getState().selectedPlano;

  const { categoriaId } = useConsorcioStore.getState();

  const { empresaId } = useInitialConfigStore.getState();

  const { cpfCnpj } = useUserStore.getState().contrato;

  const { userCupom } = useUserStore.getState();

  const { LeadID } = useUserStore.getState().lead;

  const { firstParcelBruto } = usePaymentStore.getState();

  const validateCouponProps = {
    codigo: userCupom,
    valorCredito: bemCredito,
    valor: firstParcelBruto,
    empresaId: empresaId,
    unidadeDeNegocioId: 1, //Mycon
    categoriaId: couponCategories[categoriaId],
    cpfCnpj: removeSpecialCharacters(cpfCnpj),
    canalVendaId: 2, // Canal de venda do bot
    formaPagamentoId: 0, // ?
    tipoPlanoId: tipoPlanoID,
    leadId: LeadID,
  };

  return apiWithkey.post(url, validateCouponProps);
};

export { validateForbiddenWords, validateCoupon };
